import type { Component } from './types';

import { LoadingSpinner } from '@sgcmpteltd/uikit-react';

import { loaderContainer } from './config';

import { cn } from '@/lib/utils';

export const Loader: Component = ({
  blockPage = false,
  containerClassName,
  size = 24,
  spinnerWrapperClassName,
}) => {
  return (
    <div className={cn(loaderContainer({ blockPage }), 'z-[9999]', containerClassName)}>
      {blockPage && (
        <div className="absolute inset-0 z-0 bg-[rgba(0,0,0,0.3)]" />
      )}
      <div className={cn('z-[10]', spinnerWrapperClassName)}>
        <LoadingSpinner size={size} />
      </div>
    </div>
  );
};
